module.exports = __webpack_public_path__ + "img/14.bfafbb51.jpg";